
const digest = '72de59e54d8096ff6a04e211a70173bb430735059438f6a17babeaf439c72dd6';
const classes = {"removeItemWrapper":"_removeItemWrapper_1ecs3_1","boldInformation":"_boldInformation_1ecs3_5"};
const css = `._removeItemWrapper_1ecs3_1 {
  padding: 12px;
}

._boldInformation_1ecs3_5 {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  